export default __webpack_public_path__ + "static/media/heart-line.38084391.svg";